<template>
    <v-layout column pa-4>
        <v-flex xs12 class="validation-message" pb-4 >
          {{loginConstants.errors.NOT_ABLE_TO_VALIDATE_MESSAGE}}
        </v-flex>
        <v-flex xs12 pb-2 pl-3>
          <a :href="`mailto:${loginConstants.contactUs.MEMBER_SERVICE_EMAIL}`" class="validation-message__option">
            {{ loginConstants.contactUs.MEMBER_SERVICE_EMAIL }}
          </a>
        </v-flex>
        <v-flex xs12 pl-3>
          <a :href="`tel:${loginConstants.contactUs.MEMBER_SERVICES_NUMBER}`" class="validation-message__option">
          {{ loginConstants.contactUs.MEMBER_SERVICES_NUMBER }}
          </a>
        </v-flex>
        <v-flex xs12 pt-5 pr-1>
            <v-card-actions>
                <v-btn large
                       id="return_to_home_btn"
                       data-qe-id="return_to_home_btn"
                       block
                       color="ypo_blue"
                       class="white--text"
                       @click="returnToLogin()">
                    {{loginConstants.RETURN_TO_LOGIN}}
                </v-btn>
            </v-card-actions>
        </v-flex>
    </v-layout>
</template>

<script>
    import { loginConstants } from "../login.constants";

    export default {
        name: 'ContactUsForFurtherAssistance',
        props: {
            returnToLogin: Function,
        },
        data() {
            return {
                loginConstants,
            };
        },
        methods: {
            launchEmailClient(email) {
                window.location = `mailto:${email}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

    .validation-message {
        color: $ypo-gray;
        font-size: 18px;

        &__option {
          text-decoration: none;
          font-size: 20px;
          color: $ypo-cta;

          &:hover {
            text-decoration: underline;
          }
        }
    }
</style>
